import { apiClient } from '@tacans/shared-marketplace-layer';

const downloadBlobToLocaleMachine = (blob: Blob, fileName = '') => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const downloadPrivateFile = async (url: string, id: string, outerFileName = ''): Promise<void> => {
    try {
        const { data: blob, headers = {} } = await apiClient.post<Blob>(url, { id }, { responseType: 'blob' });
        let fileName = outerFileName;
        const { contentDisposition = '' } = headers;
        const checker = 'filename=';
        const responseFileNamePair =
            (contentDisposition as string).split('; ').find((item) => item.startsWith(checker)) || '';
        if (responseFileNamePair) {
            const [, responseFileName = ''] = responseFileNamePair.split(checker);
            fileName = responseFileName.trim().replaceAll('"', '') || fileName;
        }
        await downloadBlobToLocaleMachine(blob, fileName);
    } catch {
        // do nothing
    }
};
